export default __webpack_public_path__ + "static/media/33t.f7d466e3.jpg";